export default __webpack_public_path__ + "static/media/galarie2.956206aa.jpg";